import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BlockIconTextComponent } from '@app/components/blocks/block-iconText/block-iconText.component';
import { IconTextModule } from '@app/components/iconText/iconText.module';

@NgModule({
  imports: [CommonModule, SharedModule, IconTextModule],
  declarations: [BlockIconTextComponent],
  exports: [BlockIconTextComponent],
})
export class BlockIconTextModule {}
